import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  number: '5 min',
  label: 'Setup Time',
  icon: '⚡',
  accent: '#00C9B1'
}, {
  number: '$34',
  label: 'Max Savings on VIP',
  icon: '💰',
  accent: '#FFB800'
}, {
  number: '+100',
  label: 'Happy Customers',
  icon: '🙌',
  accent: '#b4a0ff'
}, {
  number: '$198',
  label: 'Total Bundle Value',
  icon: '💎',
  accent: '#00C9B1'
}, {
  number: '★ 4.9',
  label: 'Average Rating',
  icon: '⭐',
  accent: '#FFB800'
}];
export function SocialProofBar() {
  return <section className="relative bg-[#0A1628] py-10 overflow-hidden" data-id="element-260">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal/40 to-transparent" data-id="element-261" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FFB800]/20 to-transparent" data-id="element-262" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[200px] bg-teal/4 rounded-full blur-[80px] pointer-events-none" data-id="element-263" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-264">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-id="element-265">
          {stats.map((stat, i) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08,
          duration: 0.5
        }} className="relative group text-center px-3 py-5 rounded-2xl cursor-default transition-all duration-300 hover:scale-105" style={{
          background: `radial-gradient(ellipse at 50% 0%, ${stat.accent}12 0%, transparent 70%)`,
          border: `1px solid ${stat.accent}22`
        }} data-id="element-266">
              <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
            boxShadow: `0 0 24px ${stat.accent}18`
          }} data-id="element-267" />
              <div className="w-9 h-9 rounded-xl mx-auto mb-3 flex items-center justify-center text-base" style={{
            background: `${stat.accent}15`,
            border: `1px solid ${stat.accent}28`
          }} data-id="element-268">
                {stat.icon}
              </div>
              <p className="font-display font-extrabold text-2xl sm:text-3xl mb-1.5" style={{
            background: `linear-gradient(160deg, #ffffff 30%, ${stat.accent})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-269">
                {stat.number}
              </p>
              <p className="text-xs font-medium leading-tight text-white/52" data-id="element-270">{stat.label}</p>
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full opacity-50" style={{
            background: `linear-gradient(90deg, transparent, ${stat.accent}, transparent)`
          }} data-id="element-271" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}